/*
 This file has logic for the portfolio landing page
 */
document.addEventListener('facetwp-refresh', function() {
	let isPortfolioPaginated = window.location.pathname.match(/portfolio\/page/)
	console.log('path found: ' + isPortfolioPaginated)
	if(isPortfolioPaginated) {
		// Reload the page if any filters are changed to reset the pagination
		if (FWP.loaded) {
			FWP.setHash();
			window.location.assign('/portfolio'+window.location.search);
		}
	}
});
